module.exports = __webpack_public_path__ + "img/poster.0843fe56.jpg";